import { render, staticRenderFns } from "./UploadPagePlay.vue?vue&type=template&id=5388912e&scoped=true&"
import script from "./UploadPagePlay.vue?vue&type=script&lang=js&"
export * from "./UploadPagePlay.vue?vue&type=script&lang=js&"
import style0 from "./UploadPagePlay.vue?vue&type=style&index=0&id=5388912e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5388912e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
